window._define('common/commands', ['App'], function (core) {
    'use strict';

    let self = this,
        commands = {};

    function add(commandName, func) {
        commands[commandName] = func;
    }

    function execute(commandName, args, context) {
        let ret;

        if (!Array.isArray(args)) {
            args = [args];
        }
        if (commands[commandName]) {
            ret = commands[commandName].apply(context || self, args);
        } else {
            core.warn('command "' + commandName + '" does not exist.');
        }

        return ret;
    }

    core.commands = commands;

    return {
        add,
        execute,
    };
});
